import React, { useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";

import { blogs } from "../../../constants/blogs.constant";
import { MultiLanguageUrl } from "../../../constants/multiLanguage.constant";

type Props = {};

function SiteBlogComponent({}: Props) {
  const { i18n, t } = useTranslation();
  const params = useParams();
  const navigate = useNavigate();

  const blog = blogs.find((b) => b.id === Number(params.id));

  if (!blog) {
    navigate(`/${MultiLanguageUrl[i18n.language] || "en-US"}`);
  }

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const breadcrumbs: any[] = [
    {
      name: "Home",
      link: "/"
    },
    {
      name: "Blog",
      link: ""
    }
  ];
  return (
    <section>
      <Container fluid="xl">
        <Row className="mb-5 mt-3">
          <Col md={{ span: 8, offset: 2 }}>
            <Row>
              <Col>
                <span>{blog?.createDate}</span>
              </Col>
            </Row>
            <Row className="my-3">
              <Col>
                <h1 className="font-sofiaSans fw-bolder">
                  {t(blog?.title as string)}
                </h1>
              </Col>
            </Row>
            <Row>
              <Col>
                <div className="ratio ratio-16x9">
                  <iframe
                    allow="camera; microphone"
                    src={blog?.videoLink}
                    title="YouTube video"
                    allowFullScreen
                  ></iframe>
                </div>
              </Col>
            </Row>
            <Row className="mt-3">
              <Col>{/* <h2>What does a chatbot do?</h2> */}</Col>
            </Row>
            <Row>
              <Col>{blog?.content?.map((blg: string) => <p>{t(blg)}</p>)}</Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default SiteBlogComponent;
